import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { canAccessPage } from '../constants/roleConfig';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const { isAuthenticated, isLoading, user } = useContext(AuthContext);
    const location = useLocation();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (allowedRoles.length > 0 && user?.activeRole) {
        const hasAccess = canAccessPage(user.activeRole, location.pathname);

        if (!hasAccess) {
            return <Navigate to="/" replace />;
        }
    }

    return children;
};

export default ProtectedRoute; 